import { makeAutoObservable } from "mobx";
import Usuario from '../api/usuario/usuario';
import { getError } from "../util/util";
import { toJS } from "mobx";
import { Catalogos } from "../util/catalogos";

export class UsuarioStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loading = false;
  entities = [];
  resultRequest;
  //permisosUsuario = []

  getAll = async () => {
    this.loading = true;
    try {
      const result = await Usuario.getAll();
      if (result.success) this.entities = result.data
      return Promise.resolve(true)
    } catch (error) { 
      this.displayError(error);
      return Promise.resolve(false)
    } finally {
      this.loading = false;
    }
  };

  getAllByFilter = async (data) => {
    this.loading = true;
    try {
      const result = await Usuario.getAllByFilter(data);
      if (result.success) this.entities = result.data;
    } catch (error) {
      // Alertas
    } finally {
      this.loading = false;
    }
  };

  activeOrInactive = async (id, idEstatus) => {
    this.loading = true;
    try {
      const result = await Usuario.activeOrInactive(id, idEstatus);
      return Promise.resolve(result);
    } catch (error) {
      // Alertas
      this.displayError(error);
      return Promise.resolve(false)
    } finally {
      this.loading = false;
    }
  };

  updatePerfil = async (idUsuario, idPerfil) => {
    this.loading = true;
    try {
      const result = await Usuario.updatePerfil(idUsuario, idPerfil);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(false)
    } finally {
      this.loading = false;
    }
  };

  validarDatosUsuario = async (idUsuario, data) => {
    this.loading = true;
    try {
      const result = await Usuario.validarDatosUsuario(idUsuario, data);
      return Promise.resolve(result.data);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(null);
    } finally {
      this.loading = false;
    }
  };

  create = async (data) => {
    this.loading = true;
    try {
      const result = await Usuario.create(data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.error(error);
    } finally {
      this.loading = false;
    }
  };

  update = async (id, data) => {
    this.loading = true;
    try {
      const result = await Usuario.update(id, data);
      return Promise.resolve(result)
    } catch (error) {
      this.displayError(error);
      return Promise.error(error);
    } finally {
      this.loading = false;
    }
  };

  deleteUsuario = async (id) => {
    this.loading = true;
    try {
      const result = await Usuario.delete(id);
      return Promise.resolve(result)
    } catch (error) {
      // Alertas
      return Promise.resolve(error)
    } finally {
      this.loading = false;
    }
  };

  displayError = (error) => {
    this.rootStore.alertStore.alertError(getError(error));
  }

  getInformacionUsuario = async () => {
    this.loading = true;
    try {
      const result = await Usuario.getInformacionUsuario()
      return Promise.resolve(result.data)
    } catch (error) {
      // Alertas
      this.displayError(error);
      return Promise.resolve(error)
    } finally {
      this.loading = false;
    }
  };

  updatePasswordUser = async (data) => {
    this.loading = true;
    try {
      const result = await Usuario.updatePasswordUser(data);
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.error(error);
    } finally {
      this.loading = false;
    }
  };

  getAlertasUsuario = async () => {
    this.loading = true;
    try {
      const result = await Usuario.getAlertasUsuario();
      return Promise.resolve(result);
    } catch (error) {
      this.displayError(error);
      return Promise.resolve(error);
    } finally {
      this.loading = false;
    }
  };

  consultarArchivoUsuario = async (idUsuario) => {
    this.loading = true;
    try {
      const result = await Usuario.consultarArchivoUsuario(idUsuario);
      return Promise.resolve(result);
    } catch (error) {
      return Promise.resolve(null)
    } finally {
      this.loading = false;
    }
  }



}
